import { z } from "zod";

import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";

export const installedApplianceCategoriesSchema = z.array(z.nativeEnum(EProgramApplianceCategory));

export type TInstalledApplianceCategories = z.infer<typeof installedApplianceCategoriesSchema>;
